var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton paragraph",style:(_vm.style)},_vm._l((_vm.lines),function(line,index){return _c('skeleton-line',{key:index,staticClass:"paragraph-line",style:(_vm.getLineStyle(index))})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }